import "../../css/App.css";
import "../../css/BulkLoadAsset.css";
import "../../css/PageTemplate.css";
import { useContext, useState } from "react";
import { AppContext } from "../context/AppContext";
import { IAuth } from "../../interfaces/interface";
import {
  IMessageSender,
} from "../../interfaces/messageInterface";
import { IErrorList } from "../../interfaces/popMessageInterface";
import PopMessage from "../PopMessage/PopMessage";
import axios from "axios";
import chunk from "lodash/chunk";
import HeaderTemplate from "../HeaderTemplate";
import FormInternalDivFileTemplate from "../formTemplate/FormInternalDivFileTemplate";

const BULK_SIZE = 10;

interface Props {
  title: string;
  btnText: string;
  fileName: string;
  requestType: string;
  successesText: string;
  failText: string;
  tooltipText: string;
}

function BulkLoadAsset(props: Props) {
  const {
    title,
    btnText,
    fileName,
    requestType,
    successesText,
    failText,
    tooltipText,
  } = props;
  const {
    navBarStatus,
    authorization,
    disMessage,
    navBarHandler,
    errorHandlerFunction,
  } = useContext(AppContext);
  const [auth]: IAuth[] = authorization;
  const [isNavbarOpen] = navBarStatus;
  const navBarClickHandler: (e: any) => void = navBarHandler;
  const [displayMessage]: string[] = disMessage;
  const [, setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] =
    disMessage;
  const [csvLines, setCsvLines] = useState<string[]>([]);
  const [headerLine, setHeaderLine] = useState<string>();

  const [file, setFile] = useState<File | undefined>(undefined);
  const [formFieldsValid, setFormFieldsValid] = useState({
    isVaild: false,
    displayMessage: false,
    message: "",
  });
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorList, setErrorList] = useState<IErrorList[]>([]);

  const [finishedCsvRows, setFinishedCsvRows] = useState(0);

  const errorHandler: (status: number) => string = errorHandlerFunction;

  const isDisabled = (): boolean => {
    return displayMessage !== "none" || isNavbarOpen === true;
  };
  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrorList([]);
    if (formValidation()) {
      setDisplayMessage("bulk-load");
    }
  };
  const formValidation = (): boolean => {
    let isValid = true;

    if (!formFieldsValid.isVaild) {
      setFormFieldsValid({
        isVaild: false,
        displayMessage: true,
        message: "No file selected",
      });
      isValid = false;
    }
    return isValid;
  };
  const bulkLoadAssetHandler = async () => {
    if (csvLines.length === 0) return;
    setFinishedCsvRows(0);

    const requestsBodies: IMessageSender[] = chunk(csvLines, BULK_SIZE).map((item) => {
      return {
        type: requestType,
        userId: auth.username,
        data: [headerLine, ...item].join("\n"),
      };
    });

    setDisplayMessage("processing");
    let newErrors: IErrorList[] = [];
    let successCount = 0;
    let finishedRows = 0;
    let newErrorMessage = "";
    for (const reqBody of requestsBodies) {
      // cant use requestsBodies.forEach here because of the async-await
      try {
        const res = await axios.post("/message", reqBody, auth.header);
        finishedRows += BULK_SIZE;
        if (res.data.successCount) {
          successCount += res.data.successCount;
        }
        if (res.data.status !== "OK") {
          if (res.data.errorList) {
            newErrors = [...newErrors, ...res.data.errorList];
          }
        }
        
        newErrorMessage = `${successCount} ${successesText}\n`;
        if (newErrors.length > 0) {
          newErrorMessage += `${newErrors.length} ${failText}\n`;
        }
        if (finishedRows < csvLines.length) {
          newErrorMessage += `Processing... (completed ${finishedRows} out of ${csvLines.length})\n`;
        }

        setErrorList(newErrors);
        setErrorMessage(newErrorMessage);
        setFinishedCsvRows(finishedRows);
        setDisplayMessage("error");
      } catch (e: any) {
        const errorMessage = errorHandler(e?.response.data.status);
        newErrorMessage += `\nprocess aborted:\n${errorMessage}`;
        setErrorMessage(newErrorMessage);
        setDisplayMessage("error");
      }
    }
  };

  const clearFields = () => {
    setCsvLines([]);
    setHeaderLine(undefined);
    setFile(undefined);
    setFormFieldsValid({
      isVaild: false,
      displayMessage: false,
      message: "No file selected",
    });
  };
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
    let fileList = e.target.files;
    if (fileList && fileList.length > 0) {
      let file = fileList[0];
      if (file.size <= 32000) {
        setFile(file);
        const reader = new FileReader();
        reader.onload = function () {
          let result = reader.result;
          if (typeof result === "string") {
            const _csvLines = result.split("\n").filter((line) => {
              let trimmedLine = line.replace(" ", "").replace(",", "");
              return trimmedLine.length > 0;
            });
            const _headerLine = _csvLines.shift();
            setCsvLines(_csvLines);
            setHeaderLine(_headerLine);

            setFormFieldsValid({
              isVaild: true,
              displayMessage: false,
              message: "",
            });
          }
        };
        reader.readAsText(file);
      } else {
        clearFields();
        setFormFieldsValid({
          isVaild: false,
          displayMessage: true,
          message: "File size is limited to 32K bytes",
        });
      }
    } else {
      clearFields();
      setFormFieldsValid({
        isVaild: false,
        displayMessage: false,
        message: "No file selected",
      });
    }
  };
  const fileClickHandler = (e: any): void => {
    e.target.value = "";
    clearFields();
    setFormFieldsValid({
      isVaild: false,
      displayMessage: false,
      message: "No file selected",
    });
  };

  return (
    <div className="page-template" onClick={navBarClickHandler}>
      <HeaderTemplate title={title} />
      <div
        className={
          displayMessage !== "none" || isNavbarOpen === true
            ? "page-template-main blur"
            : "page-template-main"
        }
        onClick={navBarClickHandler}
      >
        <form className="form-template" onSubmit={submitHandler}>
          <div className="form-template-top-container">
            <div className="form-template-internal-div">
              <div className="form-template-label">
                <span>Download sample file</span>
                <a href={"/files/" + fileName} download>
                  <img
                    className="file-download-img"
                    src="/icons/download-file.png"
                    alt="download-file"
                  />
                </a>
              </div>
            </div>
            <FormInternalDivFileTemplate
              id="file-upload"
              label="Upload File *"
              value={file ? file.name : ""}
              disabled={isDisabled()}
              onChange={changeHandler}
              accept=".csv"
              displayMessage={formFieldsValid.displayMessage}
              message={formFieldsValid.message}
              dataToolTip={tooltipText}
              onClick={fileClickHandler}
            />
          </div>
          {headerLine && <p>file contains {csvLines.length} assets</p>}
          <div className="form-template-div-button-one-field">
            <button
              type="submit"
              className="submit-form-btn"
              disabled={isDisabled()}
            >
              {btnText}
            </button>
          </div>
        </form>
      </div>
      {displayMessage !== "none" && (
        <div className="page-template-pop-message">
          <PopMessage
            assetHandler={bulkLoadAssetHandler}
            formData={{ fileName: file?.name }}
            type={"bulk"}
            error={errorMessage}
            errorList={errorList}
            loaderProgress={finishedCsvRows}
            loaderTotal={csvLines.length}
          />
        </div>
      )}
    </div>
  );
}

export default BulkLoadAsset;
